// import { Table } from "@tanstack/react-table";
import { useNavigate } from "react-router-dom";
import { Icon } from "~/components/ui";

// import { DataTableViewOptions } from "./view-options";

interface DataTableToolbarProps {
  // table: Table<TData>;
  toolbar?: { title?: string; actions?: React.ReactNode; backBtn?: boolean };
}
interface IProps extends DataTableToolbarProps {
  filter?: {
    placeholder: string;
    search: string;
    searchOnchange: (search?: string) => void;
  };
}

export function DataTableToolbar({ toolbar }: IProps) {
  const navigate = useNavigate();
  return (
    <div className="flex items-center justify-between">
      <div className="flex w-full items-center gap-2">
        {toolbar?.backBtn && (
          <Icon
            name="ArrowLeft"
            className="h-6 w-6 hover:cursor-pointer"
            onClick={() => navigate(-1)}
          />
        )}
        <span className="text-[28px] font-medium text-primary-500">
          {" "}
          {toolbar?.title}
        </span>
      </div>
      <div className="w-full">{toolbar?.actions}</div>
    </div>
  );
}
